/**
 * Search history list rules, the same as UserCompanyPreferenceService on the server:
 * most recent first, a repeated term (any case) moves to the front, at most 20 terms of 100 characters.
 */
const SEARCH_HISTORY_LIMIT = 20;
const SEARCH_HISTORY_TERM_MAX_LENGTH = 100;

function normalizeHistoryTerm(term) {
    return String(term ?? "")
        .replace(/\s+/g, " ")
        .trim()
        .slice(0, SEARCH_HISTORY_TERM_MAX_LENGTH);
}

// Cleaned list without blanks or repeats, capped
function normalizeHistory(terms, limit = SEARCH_HISTORY_LIMIT) {
    const seen = new Set();
    const history = [];

    for (const raw of Array.isArray(terms) ? terms : []) {
        const term = typeof raw === "string" ? normalizeHistoryTerm(raw) : "";
        if (term && !seen.has(term.toLowerCase())) {
            seen.add(term.toLowerCase());
            history.push(term);
        }
    }

    return history.slice(0, limit);
}

function addHistoryTerm(terms, term, limit = SEARCH_HISTORY_LIMIT) {
    const cleaned = normalizeHistoryTerm(term);
    if (!cleaned) return normalizeHistory(terms, limit);

    return normalizeHistory([cleaned, ...normalizeHistory(terms, limit)], limit);
}

function removeHistoryTerm(terms, term) {
    const removed = normalizeHistoryTerm(term).toLowerCase();

    return normalizeHistory(terms).filter((saved) => saved.toLowerCase() !== removed);
}

module.exports = { SEARCH_HISTORY_LIMIT, normalizeHistoryTerm, normalizeHistory, addHistoryTerm, removeHistoryTerm };
